import React from "react";
import testi1 from "../../assets/testimonial/testi (1).webp";
import testi2 from "../../assets/testimonial/testi (2).webp";
import testi3 from "../../assets/testimonial/testti (3).webp";
import "./testimonial.scss";

const testimonial = () => {
  return (
    <div className="testimonial">
      <div className="container-testimonial">
        <div className="header-testimonial">Client Testimonials</div>
        <div className="content-testimonial">
          <div className="testimonials">
            <div className="desk">
              ”Terima kasih banyak ya bantuannya. Udah dibantuin sampe akad
              kredit, walaupun sempat ada kendala pas proses bank, tapi dicariin
              solusi sampe selesai. Sekarang tinggal tunggu rumah nya jadi aja
              deh. Sekali lagi thank you ya kak”
            </div>
            <div className="profile">
              <div className="image">
                <img src={testi2} alt="testi1" />
              </div>
              <div className="nama">Annonym</div>
            </div>
          </div>
          <div className="testimonials">
            <div className="desk">
              “Sebelumnya pernah ambil rumah tapi gak didampingi sampe serah
              terima unit. Tapi sama lu didampingi terus dari awal sampe serah
              terima unit. Gua sama istri puas banget sama servicenya. Temen2
              gua juga lagi pada cari rumah nih, nanti gua referensiin lu yaa.
              Keep in touch ya bro”
            </div>
            <div className="profile">
              <div className="image">
                <img src={testi1} alt="testi2" />
              </div>
              <div className="nama">Ken</div>
            </div>
          </div>
          <div className="testimonials">
            <div className="desk">
              “Udah sempet survey rumah dimana2, ujung2nya jatuh cinta sama
              Grand Wisata di cluster Z-Living. Developer udah terbukti bagus,
              fasilitas lengkap, akses enak banget buat kemana2. Ditambah lagi
              ketemu Kak Sandy yang bisa ngertiin banget kebutuhan aku sama
              suami.”
            </div>
            <div className="profile">
              <div className="image">
                <img src={testi3} alt="testi" />
              </div>
              <div className="nama">Ica</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default testimonial;
